import React from 'react';
import './ResultScreen.scss';
import { ITEMS_TO_FIND } from '../../constants';

interface ResultScreenProps {
  isWon: boolean;
  foundItems: string[];
  onTryAgain: () => void;
  onBackToStart: () => void;
}

const ResultScreen: React.FC<ResultScreenProps> = ({
  isWon,
  foundItems,
  onTryAgain,
  onBackToStart,
}) => {
  const backgroundImage = isWon
    ? `url(${process.env.PUBLIC_URL}/images/holiday ALL ITEMS.png)`
    : `url(${process.env.PUBLIC_URL}/images/holiday TRY AGAIN.png)`;

  // If won, show video overlay on top of game background
  if (isWon) {
    return (
      <div className="result-screen result-screen--video-overlay">
        {/* Game background still visible */}
        <div
          className="result-screen__background-blur"
          style={{ backgroundImage }}
        />
        {/* Video popup in center */}
        <div className="result-screen__video-popup">
          <video
            autoPlay
            controls
            className="result-screen__popup-video"
          >
            <source src={`${process.env.PUBLIC_URL}/holiday.mp4`} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    );
  }

  // If lost, show regular result screen (not used anymore since we removed lose state)
  return (
    <div className="result-screen">
      <div
        className="result-screen__background"
        style={{ backgroundImage }}
      >
        <div className="result-screen__content">
          <h1 className="result-screen__title">
            Time's Up!
          </h1>
          <p className="result-screen__score">
            You found {foundItems.length} out of {ITEMS_TO_FIND.length} items
          </p>

          <div className="result-screen__buttons">
            <button
              className="result-screen__button result-screen__button--primary"
              onClick={onTryAgain}
            >
              TRY AGAIN
            </button>
            <button
              className="result-screen__button result-screen__button--secondary"
              onClick={onBackToStart}
            >
              BACK TO START
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultScreen;
